import type { ICalculatePlannedCreditResult } from "@vmosolutions/oc-interfaces";
import type { AnyAction } from "redux";
import type { ThunkDispatch } from "redux-thunk";
import type { INotifications } from "src/API/AmplifyAPIWrapper";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";

/**
 * The backend calculates from the pairing's SAVED content, so unsaved editor state is not included.
 *
 * @returns the records written plus any grouping whose module failed, or null when the call failed. No
 * success message is set here: a run can partly succeed, so the caller reports the outcome.
 */
export const recalculatePairingCredit = async (
  pairingId: string,
  dispatch?: ThunkDispatch<object, object, AnyAction>
): Promise<ICalculatePlannedCreditResult | null> => {
  const notifications: INotifications | undefined = dispatch
    ? {
        dispatch: dispatch,
        infoMessage: "Recalculating credit...",
        errorMessage: "Error: Unable to recalculate credit",
      }
    : undefined;
  return AmplifyAPIWrapper.Put<ICalculatePlannedCreditResult>(
    `/pairings/${pairingId}/recalculateCredit`,
    {},
    notifications
  );
};
